import { IConfigStorage } from "../IConfigStorage";
import { DataUtilities } from "../DataUtilities";
import { UnitTestResultNode } from "./UnitTestResultNode";
import { TestResultDataType } from "../Testing/TestResultDataType";

export class UnitTestConfiguration implements IConfigStorage {
    _id: string = DataUtilities.generateUniqueId();
    name: string;
    inputData: object;
    resultNode: UnitTestResultNode;
    expectError: boolean = false;
    matchResults: boolean = true;
    evaluateTestNodes: boolean = false;

    constructor(resultNode: UnitTestResultNode, inputData: object) {
        this.name = "";
        this.inputData = inputData;
        this.resultNode = resultNode;
    }

    getStorageData(): object {
        let data = DataUtilities.addStorageData(
            this,
            undefined,
            "_id",
            "name",
            "expectError",
            "matchResults",
            "evaluateTestNodes",
            "inputData"
        );
        Reflect.set(data, "resultNode", this.resultNode.getStorageData());
        return data;
    }

    setStorageData(data: object): void {
        DataUtilities.setStorageData(
            this,
            data,
            "_id",
            "name",
            "expectError",
            "matchResults",
            "evaluateTestNodes",
            "inputData"
        );
        let resData = Reflect.get(data, "resultNode");
        if (resData) {
            let result = new UnitTestResultNode("", "", "", TestResultDataType.EXPRESSION);
            result.setStorageData(resData);
            this.resultNode = result;
        }
    }
}
